// extracted by mini-css-extract-plugin
export default {"pageTitle":"result_pageTitle__LXZOF","resultWon":"result_resultWon__XOmYh","resultLost":"result_resultLost__+mVZj"};